/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtStatusListResponse } from '../../models/ddt-status-list-response';

export interface DdtControllerGetStatuses$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  name?: string;
}

export function ddtControllerGetStatuses(http: HttpClient, rootUrl: string, params: DdtControllerGetStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtStatusListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerGetStatuses.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtStatusListResponse;
      }>;
    })
  );
}

ddtControllerGetStatuses.PATH = '/ddt/status';
